<template lang='pug' src='./contact.pug'></template>

<script>
import Form from 'components/form/form'
import Icon from 'components/icon/icon'

export default {
  data () {
    return {
      active: false,
      location: 0
    }
  },
  computed: {
    props () {
      return this.$store.state.pages['contact']
    }
  },
  components: {
    Form,
    Icon
  },
  methods: {
    onLocation (i) {
      this.location = i
    }
  }
}
</script>



// WEBPACK FOOTER //
// contact.vue?3904e474